/**
 * Busca de endereço via Nominatim (OSM). Pode falhar por CORS ou política de uso em alguns ambientes.
 */
export async function searchAddressNominatim(query, options = {}) {
  const q = (query || '').trim();
  if (!q) return [];

  const country = options.countrycodes ? `&countrycodes=${options.countrycodes}` : '';
  const url = `https://nominatim.openstreetmap.org/search?format=json&limit=5&q=${encodeURIComponent(q)}${country}`;
  const res = await fetch(url, {
    headers: {
      Accept: 'application/json',
    },
  });
  if (!res.ok) throw new Error('Falha na busca de endereço');
  const data = await res.json();
  if (!Array.isArray(data)) return [];
  return data.map((item) => ({
    label: item.display_name,
    lat: Number(item.lat),
    lon: Number(item.lon),
  }));
}
